import InlineContact from "./InlineContact";

export default InlineContact;
